import { StyledStatsTab } from "./StatsSegmentTabButton.styled";

type StatsSegmentTabButtonProps = {
  selected: boolean;
  count: number;
  label: string;
  onSelect: () => void;
};

const StatsSegmentTabButton = ({
  selected,
  count,
  label,
  onSelect,
}: StatsSegmentTabButtonProps) => (
  <StyledStatsTab
    type="button"
    role="tab"
    aria-selected={selected}
    $selected={selected}
    onClick={onSelect}
  >
    <span>{count}</span>
    <span>{label}</span>
  </StyledStatsTab>
);

export default StatsSegmentTabButton;
